module.exports = __webpack_public_path__ + "img/weight.cd6d74ac.svg";